import {createFileRoute, redirect} from '@tanstack/react-router';
import Psoriasis from '@/patient/views/PathologiesInfo/Psoriasis';
import {AppRouterContext} from '@/shared/routing';
import {USER_HOME} from '@/shared/routing/paths';

export const Route = createFileRoute('/(patient)/patient/psoriasis-info')({
  component: Psoriasis,
  beforeLoad: function ({context}: {context: AppRouterContext}) {
    if (context.isPatient && context.company?.isForClinicalTrials) {
      throw redirect({to: USER_HOME, replace: true});
    }
  }
});
